import React, { useState, useEffect } from "react";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import { config } from "../CommonUtils/CommonURLS";
import Swal from "sweetalert2";
import { FaCheckCircle } from "react-icons/fa";
import { showValue } from "./ParentSection";

export default function FacultyReport() {
    const ROLEID = sessionStorage.getItem("role_id");

    const [projectdata, setProjectdata] = useState([]);
    const [selectedRows, setSelectedRows] = useState({}); // store selected rows by sno

    useEffect(() => {
        GetProjectStatusData();
    }, []);

    function GetProjectStatusData() {
        const url = `${config.url.FAC_URL}getFacultyDetails`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01" && res?.data?.fac_details?.length > 0) {
                setProjectdata(res?.data?.fac_details);
            } else {
                setProjectdata([]);
            }
        });
    }

    function handleSendBack(cfmsId) {

        Swal.fire({
            title: "Send Back to Maker?",
            text: `CFMS ID: ${cfmsId}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Send Back",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#d33",
            backdrop: false
        }).then((result) => {

            if (result.isConfirmed) {

                const url = `${config.url.FAC_URL}sendBackFacultyCfmsData?cfmsId=${cfmsId}`;

                CommonAxiosPost(url).then((res) => {

                    if (res?.data?.scode === "01") {

                        Swal.fire(
                            res?.data?.sdesc || "Sent back successfully",
                            "",
                            "success"
                        );

                        GetProjectStatusData();

                    } else {

                        Swal.fire(
                            res?.data?.sdesc || "Operation failed",
                            "",
                            "error"
                        );

                    }

                });

            }

        });
    }

    function handleBulkApprove() {
        const slnoList = Object.keys(selectedRows)
            .filter((key) => selectedRows[key])
            .map((key) => Number(key));

        if (slnoList.length === 0) {
            Swal.fire("Please select at least one faculty to approve", "", "warning");
            return;
        }

        const selectedFaculties = projectdata
            .filter((row) => slnoList.includes(row.sno))
            .map((row) => `${row.fac_name} (CFMS ID: ${row.cfms_id})`)
            .join("<br/>");

        Swal.fire({
            title: "Confirm Approval",
            html: `<strong>Selected Faculty:</strong><br/>${selectedFaculties}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Approve!",
            cancelButtonText: "Cancel",
            backdrop: false,
            confirmButtonColor: "#2e7d32",
        }).then((result) => {
            if (result.isConfirmed) {
                const url = `${config.url.FAC_URL}updateCheckerApprovalFaculty`;
                const payload = {
                    isCheckerApproved: true,
                    slnolist: slnoList,
                };
                CommonAxiosPost(url, payload).then((res) => {
                    if (res?.data?.scode === "01") {
                        Swal.fire(res?.data?.sdesc || "Approved successfully", "", "success");
                        setSelectedRows({});
                        GetProjectStatusData();
                    } else {
                        Swal.fire(res?.data?.sdesc || "Approval failed", "", "error");
                    }
                });
            }
        });
    }

    const FacultyReportColumns = [
        {
            id: "slNo",
            header: ROLEID === "4" ? (
                <input
                    type="checkbox"
                    onChange={(e) => {
                        const checked = e.target.checked;
                        const newSelected = {};
                        projectdata.forEach((row) => {
                            if (!row.is_checker_approved) newSelected[row.sno] = checked;
                        });
                        setSelectedRows(newSelected);
                    }}
                    checked={
                        projectdata.filter((r) => !r.is_checker_approved).every((r) => selectedRows[r.sno])
                    }
                />
            ) : "S.No",
            cell: ({ row }) => (
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    {ROLEID === "4" && !row.original.is_checker_approved && (
                        <input
                            type="checkbox"
                            checked={!!selectedRows[row.original.sno]}
                            onChange={(e) =>
                                setSelectedRows((prev) => ({
                                    ...prev,
                                    [row.original.sno]: e.target.checked,
                                }))
                            }
                        />
                    )}
                    <span>{row.index + 1}</span>
                </div>
            ),
        },
        {
            id: "fac_name",
            header: "Faculty Name",
            accessorKey: "fac_name",
            meta: { style: { textAlign: "left" } },
        },
        {
            id: "gender",
            header: "Gender",
            accessorKey: "gender",
        },


        {
            id: "dob",
            header: "Date of Birth",
            accessorKey: "dob",
            cell: ({ getValue }) => {
                const value = getValue();
                if (!value) return "";

                const date = new Date(value);
                return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
            }
        },
        {
            id: "doj",
            header: "Date of Joining in the University",
            accessorKey: "doj",
            meta: { style: { textAlign: "left" } },
            cell: ({ getValue }) => {
                const value = getValue();
                if (!value) return "";

                const date = new Date(value);
                return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
            }
        },
        {
            id: "cfms_id",
            header: "CFMS ID",
            accessorKey: "cfms_id",
        },
        {
            id: "masked_aadhar",
            header: "Adhaar No",
            accessorKey: "masked_aadhar",
            meta: { style: { textAlign: "left" } },
        },
        {
            id: "dept_name",
            header: "Department / Subject",
            accessorKey: "dept_name",
            meta: { style: { textAlign: "left" } },
        },
        {
            id: "designation",
            header: "Designation",
            accessorKey: "designation",
            meta: { style: { textAlign: "left" } },
        },
        {
            id: "fac_type_name",
            header: "Type of Faculty",
            accessorKey: "fac_type_name",
            meta: { style: { textAlign: "left" } },
        },
        {
            id: "caste",
            header: "Caste",
            accessorKey: "caste",
            meta: { style: { textAlign: "left" } },
        },
        {
            id: "sub_caste",
            header: "Sub Caste",
            accessorKey: "sub_caste_name",
            meta: { style: { textAlign: "left" } },
        },
        {
            id: "is_ph",
            header: "Physically Challenged",
            accessorKey: "is_ph",
            meta: { style: { textAlign: "left" } },
            cell: ({ getValue }) => {
                const value = getValue();
                return value === true ? "Yes" : value === false ? "No" : "-";
            },
        },
        {
            id: "type_of_disability",
            header: "Type of Disability",
            accessorKey: "type_of_disability",
            cell: ({ getValue }) => showValue(getValue())
        },
        {
            id: "per_disability",
            header: "Percentage of Disability",
            accessorKey: "per_disability",
            cell: ({ getValue }) => showValue(getValue())
            // meta: { style: { textAlign: "left" } },
        },
        {
            id: "appoint_cat_name",
            header: "Appointed Category",
            accessorKey: "appoint_cat_name",
            meta: { style: { textAlign: "left" } },
        },
        {
            id: "dist_name",
            header: "Local District",
            accessorKey: "dist_name",
            meta: { style: { textAlign: "left" } },
        },

        {
            id: "qualification_appoint_name",
            header: "Qualifications at the Time of Appointment",
            accessorKey: "qualification_appoint_name",
            meta: { style: { textAlign: "left" } },
            cell: ({ getValue }) => {
                const value = getValue() || "";
                const items = value.split(",").map((item) => item.trim()).filter(Boolean);
                return (
                    <span>
                        {items.map((item, idx) => (
                            <React.Fragment key={idx}>
                                {item}
                                {idx < items.length - 1 && <span>, </span>}
                            </React.Fragment>
                        ))}
                    </span>
                );
            },
        },
        {
            id: "qualification_later_name",
            header: "Qualification Acquired Later",
            accessorKey: "qualification_later_name",
            meta: { style: { textAlign: "left" } },
            cell: ({ getValue }) => {
                const value = getValue() || "";
                const items = value.split(",").map((item) => item.trim()).filter(Boolean);
                return (
                    <span>
                        {items.map((item, idx) => (
                            <React.Fragment key={idx}>
                                {item}
                                {idx < items.length - 1 && <span>, </span>}
                            </React.Fragment>
                        ))}
                    </span>
                );
            },
        },
        {
            id: "contact",
            header: "Mobile Number",
            accessorKey: "contact",
            meta: { style: { textAlign: "left" } },
        },
        {
            id: "email_id",
            header: "Email ID",
            accessorKey: "email_id",
            meta: { style: { textAlign: "left" } },
        },
        ...(ROLEID === "4"
            ? [

                {
                    id: "approve",
                    header: "Approve",
                    cell: ({ row }) => {
                        const { is_checker_approved, cfms_id } = row.original;

                        if (is_checker_approved) {
                            return (
                                <span className="status-badge status-approved">
                                    <FaCheckCircle size={16} />
                                    Approved
                                </span>
                            );
                        } else {
                            return (
                                <button
                                    className="btn-back-to-maker"
                                    onClick={() => handleSendBack(cfms_id)}
                                >
                                    Back
                                </button>
                            );
                        }
                    },
                }
            ]
            : []),





    ];

    return (

        <>

            <div className="faculty-form-wrapper">
                <div className="faculty-card">
                    <div className='fac-topbar'>

                        <div className='fac-detnew'>
                            <h5 className='mb-0'>{ROLEID === "4" ? "Faculty Details Approval Form" : "Faculty Details Report"}</h5>
                        </div>

                    </div>
                    {projectdata?.length > 0 ? (
                        // <div className="table-responsive">
                        <CommonReactTable
                            data={projectdata}
                            columns={FacultyReportColumns}
                            filename="Faculty Details Report"
                            headerName={ROLEID === "4" ? "Faculty Details Approval" : "Faculty Details Report"}
                            showPagination={true}
                            showExcel={true}
                            showPrint={true}
                            showFooter={false}
                            excelFileName="Faculty Details Report"


                        />
                        // </div>
                    ) : (
                        <center className="text-danger h5">**** No Data Found ****</center>
                    )}

                    {ROLEID === "4" && projectdata?.length > 0 && (
                        <div className="text-end mt-3">
                            <button
                                type="button"
                                className="submit-btn btn-sm btn"
                                style={{ marginBottom: "10px" }}
                                onClick={handleBulkApprove}
                                disabled={!Object.values(selectedRows).some(Boolean)}
                            >
                                Approve Selected
                            </button>
                        </div>
                    )}
                </div>
            </div>

        </>
    );
}